import React from 'react';
import { infoPageStyles as styles } from './sharedStyles';

const Partnerships = () => {
  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Partnerships</h1>
        <p style={styles.headerSubtitle}>
          Building stronger connections across the ISU community
        </p>
      </div>

      <div style={styles.contentContainer}>

        {/* Our Partners */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Our Partners</h2>
          <div style={styles.highlight}>
            <h3 style={styles.highlightTitle}>Illinois State University Student Government Association (SGA)</h3>
            <p style={styles.text}>
              Redbird Markets proudly collaborates with the Illinois State University Student Government Association (SGA) to promote student innovation and campus engagement.
            </p>
            <p style={styles.text}>
              Through this partnership, we aim to connect students with safe, verified opportunities to exchange items, ideas, and experiences.
            </p>
          </div>
        </div>

        {/* Future Collaborations */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Future Collaborations</h2>
          <p style={styles.text}>
            We're always looking to partner with student organizations, academic departments, and local sponsors who share our commitment to empowering students.
          </p>
          
          <div style={styles.highlight}>
            <h3 style={styles.highlightTitle}>Interested in working with us?</h3>
            <p style={styles.text}>
              Contact us at{' '}
              <a 
                href="mailto:redbirdmarket.isu@gmail.com" 
                style={styles.link}
              >
                redbirdmarket.isu@gmail.com
              </a>
            </p>
          </div>
        </div>

        {/* Partnership Benefits */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Why Partner With Us?</h2>
          
          <h3 style={styles.subsectionTitle}>Student-Driven Impact</h3>
          <p style={styles.text}>
            Connect directly with the ISU student community through authentic, peer-to-peer engagement.
          </p>

          <h3 style={styles.subsectionTitle}>Campus-Wide Reach</h3>
          <p style={styles.text}>
            Access to verified ISU students, faculty, and staff across all departments and organizations.
          </p>

          <h3 style={styles.subsectionTitle}>Innovation Focus</h3>
          <p style={styles.text}>
            Partner with forward-thinking students who are building the future of campus commerce.
          </p>

          <h3 style={styles.subsectionTitle}>Community Values</h3>
          <p style={styles.text}>
            Align with our mission of safety, trust, and meaningful student connections.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Partnerships;